import Icon from '../common/Icon';
import { useChatSession } from '../context/ChatSessionContext';
import { useFeatureFlags } from '../context/FeatureFlagsContext';
import { useDrawer } from '../context/DrawerContext';

/**
 * AgentChip — the current guide's name.
 *
 * Flag `agent_switcher` ON → a tappable pill (chevron) that opens the guide
 * switcher drawer (same drawer UI as Language/Explore/etc.). OFF (default, incl.
 * prod) → the plain non-interactive guide name pill.
 */
export default function AgentChip() {
  const { agent } = useChatSession();
  const { isEnabled } = useFeatureFlags();
  const { openDrawer } = useDrawer();

  const name = agent?.displayName;
  if (!name) return null;

  if (!isEnabled('agent_switcher', false)) {
    return <span className="dash__agent-pill">{name}</span>;
  }

  return (
    <button
      type="button"
      className="dash__agent-pill dash__agent-pill--button"
      onClick={() => openDrawer('agentSwitcher')}
      aria-label="Change guide"
      data-testid="agent-chip"
    >
      <span>{name}</span>
      <Icon name="chevron-down" size={14} color="rgba(255,255,255,0.85)" />
    </button>
  );
}
